import { AbstractComponentPropTypes } from '../../../../ui/cms/registries';
import { ImageDefination } from '../../types/common';

export interface ContentCardCommonProps {
  imageList?: ImageDefination[];
  tag?: string;
  title?: string;
  description?: string;
  backgroundColor?: string;
  color?: string;
  themeColor?: string;
  themeShade?: string;
  url?: string;
  target?: string;
}
export interface ContentCardProps extends AbstractComponentPropTypes, ContentCardCommonProps {
  type?: ContentType;
  resourceType?: ContentResourceType;
  time?: string;
  date?: string;
  size?: string;
  startDate?: string;
  firstAccountTypeTitle?: string;
  secondAccountTypeTitle?: string;
  firstAccountTypeDate?: string;
  secondAccountTypeDate?: string;
}

type ContentType = keyof typeof Contents;
export enum Contents {
  promotion = 'promotion',
  article = 'article',
  resource = 'resource',
}

type ContentResourceType = keyof typeof ResourceType;
export enum ResourceType {
  image = 'image',
  video = 'video',
  pdf = 'pdf',
  audio = 'audio',
}

export enum Icons {
  Image = 'image',
  Video = 'video',
  PDF = 'file-pdf',
  Audio = 'volume',
}

export { ContentType, ContentResourceType };
